// extracted by mini-css-extract-plugin
module.exports = {"score":"style-module--score--2orSr","overlay":"style-module--overlay--3tHXf"};